<div class="inner-container bg-white section-gap-lg not-found-page">
    <div class="container">
        <div fxLayout="row wrap" fxLayoutAlign="center center">
            <div
                fxFlex.xs="100"
                fxFlex.sm="100"
                fxFlex.md="80"
                fxFlex.lg="40"
                fxFlex.xl="40"
            >
                <mat-card class="text-center pb-5">
                    <img  loading="lazy" 
                        src="https://us.123rf.com/450wm/jemastock/jemastock1811/jemastock181111584/112376275-website-under-construction-computer-smartphone-and-laptop-with-tower-vector-illustration-graphic-des.jpg?ver=6"
                           alt="image"
                    />
                    <h5 class="mt-3">
                        {{
                            lang == "en"
                                ? environmentVariables?.message_en ||
                                  "ًwebsite is Under Construction"
                                : environmentVariables?.message_ar ||
                                  environmentVariables?.message_en ||
                                  "الموقع تحت الانشاء"
                        }}
                    </h5>
                </mat-card>
            </div>
        </div>
    </div>
</div>
